

























  import Vue, { PropType } from 'vue';
  import { ConsultationDemandeLigne } from '..';

  export default Vue.extend({
    name: 'ConsultationDemandeTableauLigne',
    props: {
      ligne: {
        type: Object as PropType<ConsultationDemandeLigne>,
        required: true,
      },
      sectionExpension: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      valeurFormatee(): string {
        if (typeof this.ligne.valeur === 'boolean') {
          return this.ligne.valeur
            ? this.$t('commun.oui').toString()
            : this.$t('commun.non').toString();
        }

        return (this.ligne.valeur as string)?.toString();
      },
    },
  });
